import { View } from "react-native";
import type { ViewProps } from "react-native";

import { useCustomTheme } from "../hooks/useCustomTheme";

export const ThemedView = ({ style, ...rest }: ViewProps) => {
  const { colors } = useCustomTheme();

  return (
    <View style={[{ backgroundColor: colors.background }, style]} {...rest} />
  );
};
